<template>
<div class="chapter">
<div class="inner_page">
<p class="C764"><strong><a id="page_xi">Prefatory Note</a></strong></p><a id="page_xi">
<p class="P51">This volume contains revised versions of the papers presented at the Conference on Research in Income and Wealth titled “Measuring and Understanding the Distribution and Intra/Inter-Generational Mobility of Income and Wealth,” held in Bethesda, Maryland, on March 5–6, 2020.</p>
<p class="P4">We gratefully acknowledge the financial support for this conference provided by the Stone Center on Socio-Economic Inequality at the CUNY Graduate Center, the Stone Wealth and Income Inequality Project at Brown University, Statistics of Income (SOI)/Internal Revenue Service (SOI), Opportunity Insights, and the NBER. Support for the general activities of the Conference on Research in Income and Wealth is provided by the following agencies: Bureau of Economic Analysis, Bureau of Labor Statistics, the Census Bureau, the Board of Governors of the Federal Reserve System, SOI/IRS, and Statistics Canada.</p>
<p class="C813">We thank Raj Chetty, John N. Friedman, Janet C. Gornick, Barry Johnson, and Arthur Kennickell, who served as conference organizers and as editors of the volume.</p>
<p class="C816">Executive Committee, November 2020</p>
<p class="C817">Katharine G. Abraham (chair)</p>
<p class="C817">John M. Abowd</p>
<p class="C817">Susanto Basu</p>
<p class="C817">Ernst R. Berndt</p>
<p class="C817">Alberto Cavallo</p>
<p class="C817">Carol A. Corrado</p>
<p class="C817">Lucy Eldridge</p>
<p class="C817">John C. Haltiwanger</p>
<p class="C817">Ron S. Jarmin</p>
<p class="C817">J. Bradford Jensen</p>
<p class="C817">Barry Johnson</p>
<p class="C817">Greg Peterson</p>
<p class="C817">Valerie A. Ramey</p>
<p class="C817">Peter K. Schott</p>
<p class="C817">Daniel E. Sichel</p>
<p class="C817">Erich H. Strassner</p>
<p class="C817">William Wascher</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Prefatory_Note.vue?ded0f88e